export default __webpack_public_path__ + "static/event8-cab772fcd02b162dadbb90a075daca8b.jpg";